import { DynamicDash } from "./DynamicDash";

export default DynamicDash;